import { ISubscriptionsProlongAndHoldCurrentSubscriptionResponseError } from '../../../repositories/billing-subscriptions/v2/subscriptions-prolong-and-hold-current-subscription';
import { IProlongAndHoldSubscriptionError } from '../types';

export const mapResponse400 = (
  response: ISubscriptionsProlongAndHoldCurrentSubscriptionResponseError,
): IProlongAndHoldSubscriptionError => {
  const { message } = response;

  return {
    isSuccess: false,
    message,
  };
};
